import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/remainingSessionsSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const GroupBy = () => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.sessions.filters.group_by);
  const selectedFilters = useSelector((state) => state.sessions.selectedFilters.group_by);

  return (
    <MultiSelectDropdown
      height={324}
      options={options}
      selectedFilters={selectedFilters}
      placeholder="Select Group by"
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updateFilters({ group_by: data }))}
    />
  );
};

export default GroupBy;
